import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Wrapper, Label, ActionsWrapper } from './styles';
import ListItemActionButton from '../../../containers/ListItem/ActionButton';
import SelectionToggler from '../../../containers/Selection/Toggler';
import { SelectionType } from '../../../containers/Selection/actions';
import UnreadBadge from '../../../containers/CoverFlow/UnreadBadge';
import DownloadStatus from '../../../containers/CoverFlow/DownloadStatus';
import ProposalStatus from '../../ListItem/ProposalStatus';
import DriveItemUtils, { ResolutionDisplayType } from '../../../utils/driveItem';
import { Api } from '../../../typings/api';
import IndexedDBManager from '../../../utils/indexedDB/manager';

interface AdditionalItem {
	id: number;
	type: Api.AssetType;
}

interface ItemInfoProps {
	currentDriveItem: Api.DriveItem | AdditionalItem;
	isNavigationItem: boolean;
	label: string;
	isEmptyContextualMenu: boolean;
}

const ItemInfo = ({
	currentDriveItem,
	isNavigationItem,
	label,
	isEmptyContextualMenu,
}: ItemInfoProps) => {
	const [noteLabel, setNoteLabel] = React.useState('');
	const { id, type } = currentDriveItem;
	const { format, proposalStats } = currentDriveItem as Api.DriveItem;
	const driveItemTypeKey = DriveItemUtils.getAssetTypeTranslationKey(type, format);
	const isNote = type === Api.AdditionalItemType.Note;

	React.useEffect(() => {
		if (isNote) {
			IndexedDBManager.getNote(id).then((note) => {
				if (note) {
					setNoteLabel(note.title);
				}
			});
		}
	}, [id]);

	const getLabel = () => {
		if (isNavigationItem) {
			return <Translate value={label} />;
		} else if (isNote) {
			return noteLabel;
		}

		return DriveItemUtils.getDisplayName(currentDriveItem as Api.DriveItem);
	};

	return (
		<Wrapper>
			<Label>
				<span>{getLabel()}</span>
				{'|'}
				<Translate value={driveItemTypeKey} />
				{proposalStats && <ProposalStatus stats={proposalStats} />}
				<UnreadBadge id={id} />
				<DownloadStatus
					id={id}
					isRowView={false}
				/>
			</Label>
			{!isNavigationItem &&
				<ActionsWrapper>
					{!isEmptyContextualMenu && !isNote &&
						<ListItemActionButton
							isRowView={false}
							itemId={id}
							onContextualMenuHover={() => undefined}
							isActiveIcon={false}
						/>
					}
					<SelectionToggler
						itemId={id}
						displayMode={ResolutionDisplayType.Coverflow}
						selectionType={isNote ? SelectionType.NOTES : SelectionType.RESOURCES}
					/>
				</ActionsWrapper>
			}
		</Wrapper>
	);
};

export default ItemInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/ItemInfo/index.tsx